export {NavigationComponent} from './navigation.component';
export {BigBreadcrumbsComponent} from './big-breadcrumbs.component';
export {MinifyMenuComponent} from './minify-menu.component';
export {SmartMenuDirective} from './smart-menu.directive';

export {NavigationModule} from './navigation.module'



// WEBPACK FOOTER //
// ./src/app/shared/layout/navigation/index.ts